export default __webpack_public_path__ + "static/media/img-error-404.dc8a4fee.svg";